import { Outlet } from 'react-router-dom';
import { CassemsCartProvider } from '../contexts/CassemsCartContext';

export default function CassemsShell() {
  return (
    <CassemsCartProvider>
      <Outlet />
    </CassemsCartProvider>
  );
}
